/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Choose_FileInputs */

const en_choose_file = /** @type {(inputs: Choose_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose File`)
};

const es_choose_file = /** @type {(inputs: Choose_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elegir archivo`)
};

/**
* | output |
* | --- |
* | "Choose File" |
*
* @param {Choose_FileInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const choose_file = /** @type {((inputs?: Choose_FileInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Choose_FileInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_choose_file(inputs)
	return es_choose_file(inputs)
});